/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
const React = require("react")
const { AuthProvider } = require('./src/components/AuthContext')
const { GraphQL, GraphQLProvider } = require("graphql-react")
require("./src/styles/app.less")

const graphql = new GraphQL();

exports.wrapRootElement = ({ element }) => {
    return (
        <GraphQLProvider graphql={graphql}>
            <AuthProvider>
                {element}
            </AuthProvider>
        </GraphQLProvider>
    )
}